import { ActionContext } from "vuex";
import IState from "@/interfaces/IState";
import IAppConfig from "@/interfaces/astrology/appConfig/IAppConfig";

export default async function updateAppConfig(
  context: ActionContext<IState, IState>,
  data: IAppConfig
) {
  await context.dispatch("backendTalker", {
    request: "updateAppConfig",
    data,
  });
}
